/* Copied from assets/collection-top.js */
function l() {
  var thumbnails = ".js-color-thumbnails";
  $(thumbnails).slick({
    mobileFirst: !0,
    accessibility: !1,
    arrows: !1,
    dots: !1,
    slidesToShow: 2.5,
    infinite: !1,
    focusOnSelect: !0,
    centerPadding: "15px",
    responsive: [{
      breakpoint: 768,
      settings: 'unslick'
    }]
  });
  $(window).on("resize orientationchange", function () {
    $(thumbnails).slick('resize');
  });

  var t = ".p-color-variation",
    n = "".concat(t, "__sliders"),
    i = "".concat(t, "__slides"),
    o = "".concat(t, "__thumbnail"),
    r = !1;
  $(n).on("beforeChange", function (m, t, n, i) {
    r = !0;
    $(".p-color-variation__thumbnail").removeClass('is-active');
    $(".p-color-variation__thumbnail").eq(i).addClass('is-active');
  }).on("afterChange", function (m, t, n) {
    r = !1;
  }).slick({
    dots: !1,
    arrows: !1,
    swipe: !1,
    infinite: !1
  });
  p_color_variation_slick = $(i).slick({
    dots: !0,
    arrows: !0
  });
  $(o).on("click", function () {
    if (r) return;
    var t = $(this).index();
    $(o).removeClass("is-active");
    $(this).addClass("is-active");
    $(i).slick("slickGoTo", t);
  });
}
l();
